<div [formGroup]="form">
<div class="section-container">
    <div class="section-title">
        <mat-icon class="material-symbols-outlined">payments</mat-icon>
        <span>CBS</span>
        <div class="section-title-actions ms-auto">
            <button mat-button type="button" class="btn-section" (click)="abrirTabelaAliquota()">
                <mat-icon class="material-symbols-outlined">table_chart</mat-icon>
                Tabela alíquota CBS
            </button>
            <button mat-button type="button" class="btn-section" [matBadge]="personalizadasCount" [matBadgeHidden]="personalizadasCount === 0" (click)="abrirEditorFormulas()">
                <mat-icon class="material-symbols-outlined">settings</mat-icon>
                Personalizar fórmulas
            </button>
        </div>
    </div>

    <app-ativacao-section-card
        [control]="reducaoControl"
        titulo="Redução de alíquota"
        [exibirTituloNoAlerta]="false"
        descricaoAtivo="Redução ativa. O percentual abaixo reduz a alíquota de CBS aplicada no cálculo."
        descricaoInativo="Redução inativa. A alíquota cheia de CBS será aplicada no cálculo."
        emptyStateTitulo="Redução de alíquota desativada"
        emptyStateDescricao="Ative a redução acima para informar o percentual de redução e a alíquota efetiva reduzida de CBS.">
    </app-ativacao-section-card>

    @if (reducaoControl.value) {
    <div class="sub-section-container">
        <div class="sub-section-title">
            <mat-icon class="material-symbols-outlined">trending_down</mat-icon>
            <span>Redução de alíquota</span>
        </div>
        <div class="row g-3">
            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Redução (%)</mat-label>
                    <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pRedAliq">
                    <mat-error>{{ form.get('pRedAliq')?.hasError('min') ? 'O percentual de redução da CBS deve estar entre 0 e 100.' : 'Informe o percentual de redução da CBS.' }}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
    }

    <app-ativacao-section-card
        [control]="diferimentoControl"
        titulo="Diferimento"
        [exibirTituloNoAlerta]="false"
        descricaoAtivo="Diferimento ativo. O percentual abaixo será aplicado no diferimento da CBS."
        descricaoInativo="Diferimento inativo. Nenhum percentual de CBS será diferido."
        emptyStateTitulo="Diferimento desativado"
        emptyStateDescricao="Ative o diferimento acima para informar o percentual de CBS diferido.">
    </app-ativacao-section-card>

    @if (diferimentoControl.value) {
    <div class="sub-section-container">
        <div class="sub-section-title">
            <mat-icon class="material-symbols-outlined">schedule</mat-icon>
            <span>Diferimento</span>
        </div>
        <div class="row g-3">
            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Diferimento (%)</mat-label>
                    <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pDif">
                    <mat-error>{{ form.get('pDif')?.hasError('min') ? 'O percentual de diferimento da CBS deve estar entre 0 e 100.' : 'Informe o percentual de diferimento da CBS.' }}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
    }

    <div [matTooltip]="cashbackHabilitado ? '' : cashbackTooltip" matTooltipPosition="above">
        <app-ativacao-section-card
            [control]="devolucaoControl"
            titulo="Devolução de tributo (cashback)"
            [exibirTituloNoAlerta]="false"
            descricaoAtivo="Cashback ativo. O percentual abaixo de CBS será devolvido ao consumidor final, nos termos do art. 118 da LC 214/2025."
            descricaoInativo="Cashback inativo. Nenhum valor de CBS será devolvido ao consumidor final."
            emptyStateTitulo="Devolução de tributo desativada"
            emptyStateDescricao="Ative a devolução acima para informar o percentual de CBS devolvido ao consumidor final (cashback).">
        </app-ativacao-section-card>
    </div>

    @if (devolucaoControl.value) {
    <div class="sub-section-container">
        <div class="sub-section-title">
            <mat-icon class="material-symbols-outlined">currency_exchange</mat-icon>
            <span>Devolução de tributo (cashback)</span>
        </div>
        <div class="row g-3">
            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Devolução (%)</mat-label>
                    <input matInput type="text" inputmode="numeric" [currencyMask]="percentMask" formControlName="pDevTrib">
                    <mat-error>{{ form.get('pDevTrib')?.hasError('min') ? 'O percentual de devolução da CBS deve estar entre 0 e 100.' : 'Informe o percentual de devolução da CBS.' }}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
    }
</div>
</div>
